import { Component, OnInit } from '@angular/core';
import { LoaderService } from '../../../app/services/loader.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { AuthService } from '../../../app/services/auth.service';
import { GigyaSessionService } from '../../../app/services/gigya-session.service';
import { AppHelperService } from '../../../app/services/app-helper.service';

@Component({
    selector: 'group-selection',
    templateUrl: './group-selection.template.html',
    styleUrls: ['./group-selection.style.scss', '../../../shared/components/product-view/product-view-primary.style.scss', '../../../shared/components/product-view/product-view-secondary.style.scss'],
    standalone: false
})

export class GroupSelection implements OnInit {
  private spaceId: string;
  private productCode: string;
  private classId: string;
  private itemId: string;

  public isTeacher: Boolean  = false;
  public productViewData: any;
  public userData: any;
  public backagroundImage: string = '';
  public productTitle: string = '';
  public activeGroupsData: any = [];
  public archivedGroupsData: any = [];
  public sortByDateActiveGroupAsc: boolean = false;
  public sortByDateArchiveGroupAsc: boolean = false;
  public unitIndex;
  public imagesBasePath: string = IMAGES_BASEPATH;
  lessonIndex;activityIndex;selectedActivity;

  constructor(
    private loaderService: LoaderService,
    private authService: AuthService,
    private gigyaSessionService : GigyaSessionService,
    private appHelperService : AppHelperService,
    private route: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit() {
    this.userData = this.authService.getUserData();
    this.route.params.subscribe((params: Params) => {
      this.spaceId = params.spaceId;
      this.productCode = params.productCode;
      this.classId = params.classId;
      this.itemId = params.itemId;
      this.productViewData = this.route.snapshot.data.productViewResolverData;
      const bundleProduct = this.productViewData.bundleDetails.products.find(p => p['dls-product'] && p['dls-product'].code === this.productCode);
      this.productTitle = bundleProduct.meta.title;
      
      let folderPath=this.itemId.split('/');
      let toc= this.productViewData.toc.tocArray.result;
      this.unitIndex = toc.findIndex( res => res['item-code']==folderPath[0]);
      this.lessonIndex = toc[this.unitIndex].items.findIndex( res => res['item-code']==(folderPath[0]+'/'+folderPath[1]));
      this.activityIndex = toc[this.unitIndex].items[this.lessonIndex].items.findIndex( res => res['item-code']==this.itemId);
      this.selectedActivity = toc[this.unitIndex].items[this.lessonIndex].items[this.activityIndex];

      let groupsData:any =  (this.productViewData.groupDetails && this.productViewData.groupDetails.count) ?this.productViewData.groupDetails.entities:[];
      this.activeGroupsData = groupsData.filter((groupInfo)=> {
        return !groupInfo.archived;
      });
      this.archivedGroupsData = groupsData.filter((groupInfo)=> {
        return groupInfo.archived;
      });
      if(this.productViewData.productDetails.meta && this.productViewData.productDetails.meta.model && this.productViewData.productDetails.meta.paths) {
        this.backagroundImage = this.isAbsoluteUrl(this.productViewData.productDetails.meta.model.media_mast_head_bg) ? this.productViewData.productDetails.meta.model.media_mast_head_bg : this.productViewData.productDetails.meta.paths['public-assets'] + '/' + this.productViewData.productDetails.meta.model.media_mast_head_bg;
      }
      this.loaderService.hideLoader();
    });
  }

  launchItem(groupId) {
    this.loaderService.showOverlayLoader();
    this.router.navigate(['teacher',this.spaceId,'class',this.classId,'product',this.productCode,'view','item',this.itemId], {queryParams: {'group':groupId}});
  }

  navigateToHome(){
    this.router.navigate(['teacher',this.spaceId,'class',this.classId,'product',this.productCode]);
  }

  isAbsoluteUrl(url) {
    let pattern = /(^https?:\/\/)|(^\/\/)/i;
    return pattern.test(url)
  }

  navigateToDashboard() {
    this.appHelperService.navigateToDashboardApp([]);
  }

  logOut() {
    // Auth Service Logout
    this.authService.logOut().toPromise().then(
      (res) => {
        if (res.success) {
          // Gigya Service Logout
          this.authService.clearUserdata();
          return this.gigyaSessionService.gigyaLogout();
        }
      }
    ).then(() => {
      // On Logout navigate to home page
      this.appHelperService.navigateToOnboardingApp(['home']);
    });
  }

  getProdCodeForCoverImage() {
    let productCode = this.productViewData && this.productViewData.bundleDetails && this.productViewData.bundleDetails.attribs && this.productViewData.bundleDetails.attribs['cover-product-code'];
    if (!productCode) {
      productCode = this.productViewData && this.productViewData.productDetails && this.productViewData.productDetails.meta && this.productViewData.productDetails.meta.productcode;
    }
    return productCode;
  }
}